import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { CloseIcon, History } from '@yme/assets/icons';
import { MiniButton } from '@yme/atoms/mini-button';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { getSearchHistoryRootLangKey } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { getSearchResultLinkParams } from './helpers';
import { LinkHistoryWrapperStyled, SearchItemStyled } from './styled';
export function SearchHistoryItem({ historyText, historyData, setHistoryData, isActive, searchResultsPageUrl, handleClickLink, }) {
    const searchHistoryKey = useSelector(getSearchHistoryRootLangKey);
    const onClickLink = useCallback(() => {
        handleClickLink(historyText);
    }, [handleClickLink, historyText]);
    const handleDeleteHistoryClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
            const newHistoryArray = historyData.filter((historyItem) => historyItem !== historyText);
            setHistoryData(newHistoryArray);
            sessionStorage.setItem(searchHistoryKey, JSON.stringify(newHistoryArray));
        }, 0);
    }, [historyData, historyText, searchHistoryKey, setHistoryData]);
    return (React.createElement(SearchItemStyled, { isActive: isActive },
        React.createElement(LinkHistoryWrapperStyled, { to: {
                pathname: searchResultsPageUrl,
                search: getSearchResultLinkParams(historyText),
            }, onClick: onClickLink },
            React.createElement(FlexWrapper, { alignItems: "center", gap: "8px" },
                React.createElement(SVGIcon, { size: ICON_SIZE.xs, type: History }),
                historyText),
            React.createElement(MiniButton, { isPaddingsReset: true, onClick: handleDeleteHistoryClick },
                React.createElement(SVGIcon, { type: CloseIcon })))));
}
